import { getAuth } from "firebase/auth";
import { ref as databaseRef, onValue, query } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";
import Firebase from "../firebase_settings/index.js"
import Error from "./error.js"

const database = Firebase.database;
const auth = getAuth()

//メールアドレスのバリデーション
const mailValidation = (Email) => {
    //正規表現のオブジェクトを生成
    const extensionRegExp = new RegExp(/[a-z\d][\w.+_-]+@[\w.-]+\.[a-z\d]/, 'i')
    //パターンマッチング
    if(!extensionRegExp.test(Email)) {
        alert(Error.errorResult({ code: 'CME0001' }, 'common'))
        return false
    }
    return true
}

//企業コードの取得
const getCorporateId = async () => {
    const getDataRef = databaseRef(database, `LoginUser/${auth.currentUser.uid}/CorporateId`);
    return new Promise((resolve) => {
        onValue(getDataRef, (snapshot) => {
            resolve(snapshot.val() ? snapshot.val() : undefined);
        })
    });
}

//企業の端末一覧の取得
const getTerminals = async (corporateId) => {
    const settingsRef = databaseRef(database, `CorporateId/${corporateId}/Terminals`)
    return new Promise((resolve) => {
        onValue(settingsRef, (snapshot) => {
            resolve(snapshot.val() ? snapshot.val() : undefined);
        })
    });
}

//企業のアプリ設定情報の取得
const getAppSetting = async (corporateId) => {
    const settingsRef = databaseRef(database, `CorporateId/${corporateId}/AppSettings`)
    return new Promise((resolve) => {
        onValue(settingsRef, (snapshot) => {
            resolve(snapshot.val() ? snapshot.val() : undefined);
        })
    });
}

//企業情報の取得
const getCorporateInfo = async (corporateId) => {
    const settingsRef = databaseRef(database, `CorporateId/${corporateId}/CorporateInfo`)
    return new Promise((resolve) => {
        onValue(settingsRef, (snapshot) => {
            resolve(snapshot.val() ? snapshot.val() : undefined);
        })
    });
}

//プラン情報の取得
const getPlanInfo = async () => {
    const settingsRef = databaseRef(database, `PlanInformation`)
    return new Promise((resolve) => {
        onValue(settingsRef, (snapshot) => {
            resolve(snapshot.val() ? snapshot.val() : undefined);
        })
    });
}

//登録者の取得
const getRegister = async (corporateId) => {
    const getData = databaseRef(database, `CorporateId/${corporateId}/User`);
    return new Promise((resolve) => {
        onValue(getData, (snapshot) => {
            resolve(snapshot.val() ? snapshot.val() : {});
        })
    })
}

//全企業コードの一覧を取得する
const getCorporateIdList = async() => {
    const corporateIdListData = databaseRef(database, `CorporateIdList/`);
    return await new Promise((resolve) => {
        onValue(corporateIdListData, (snapshot) => {
            resolve(snapshot.val());
        });
    });
}

const functions = getFunctions(Firebase.firebaseApp, 'asia-northeast1');
const callFirebaseFunction = async (functionName, data) => {
    const callable = httpsCallable(functions, functionName, { timeout: 550 * 1000 });
    const result = await callable(data);
    return result
};

export default {
    getCorporateId,
    getAppSetting,
    getTerminals,
    getCorporateInfo,
    getPlanInfo,
    getRegister,
    getCorporateIdList,
    mailValidation,
    callFirebaseFunction
};